import { render, staticRenderFns } from "./OldWoononOrderShowItemsCard.vue?vue&type=template&id=5dabb88a"
import script from "./OldWoononOrderShowItemsCard.vue?vue&type=script&lang=ts"
export * from "./OldWoononOrderShowItemsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports